import React from 'react';
import { Icon } from 'antd';

export const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        _id: 'name',
        align: 'center',
    },
    {
        title: 'Abbreviation',
        dataIndex: 'abbr',
        _id: 'abbr',
        align: 'center',
    },
    {
        title: 'Old Crm Affiliate ID',
        dataIndex: 'old_crm_affiliate_id',
        _id: 'old_crm_affiliate_id',
        align: 'center',
    },
    {
        title: 'Loans Affiliate ID',
        dataIndex: 'loans_affiliate_id',
        _id: 'loans_affiliate_id',
        align: 'center',
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
        _id: 'actions',
        align: 'center',
        render: () => <Icon type="edit" />,
    },
];



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates/statics.js